<template>
  <div class="container page">
    <van-nav-bar :title="$t('setting.language')" class="nav-bar">
      <template #left>
        <van-icon name="arrow-left" color="#fff" @click="back()" />
      </template>
    </van-nav-bar>
    <div class="items">
      <div
        v-for="item in languageOptions"
        :key="item.code"
        class="item van-hairline--bottom"
        @click="changeLang(item)"
      >
        <div class="flex_center">
          <div class="lang-badge">{{ item.short || item.label }}</div>
          <div class="info">{{ item.fullLabel || item.label || item.code }}</div>
        </div>
        <div v-if="lang === (item.appLang || item.code)">✓</div>
      </div>
    </div>
  </div>
</template>

<script>
import { Toast } from "vant";
import {
  LANGUAGE_OPTIONS,
  applyAppLanguage,
  readSavedLanguageOption,
} from "@/common/languages";
import { resolveLanguageOptions } from "@/common/kefu";

export default {
  name: "Language",
  data() {
    const current = readSavedLanguageOption();
    return {
      lang: current.appLang,
      source: "",
    };
  },
  computed: {
    languageOptions() {
      const baseInfo = this.$store.getters.getBaseInfo || {};
      return resolveLanguageOptions(baseInfo, LANGUAGE_OPTIONS);
    },
  },
  mounted() {
    this.source = this.$route.params.type;
    const current = readSavedLanguageOption();
    this.lang = current.appLang;
    if (this.$i18n.locale !== current.appLang) {
      applyAppLanguage(this, current, { emit: false });
    }
  },
  methods: {
    back() {
      return window.history.back();
    },
    changeLang(item) {
      Toast.loading({
        duration: 200,
      });
      const language = applyAppLanguage(this, item);
      this.lang = language.appLang;
      if (this.source == "setting") {
        this.$router.push({ path: "/" });
      } else {
        this.$router.go(-1);
      }
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../assets/css/base.less";
.container .items {
  background-color: @theme1;
  font-size: 30px;
  color: @theme2;
  padding: 0 25px;
}
.container .items .item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 100px;
}
.container .items .item .flex_center {
  display: flex;
  align-items: center;
}
.container .items .item .lang-badge {
  width: 64px;
  height: 64px;
  margin-right: 20px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.12);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 22px;
  font-weight: 600;
}
.container .items .item .info {
  font-size: 30px;
}
</style>
